import { DataResult } from '@progress/kendo-data-query';
import {NexResponsePriceMode} from "../locations/NexResponsePriceMode";

export interface LotModel {
  id: number;
  lotName: string;
  lotNumber: string;
  region: string;
  regionCode: number | null;
  manager: string;
  street: string;
  city: string;
  state: string;
  physicalLayout: string;
  operation_Mode: string;
  managerPhone: string;
  managerEmail: string;
  lotPhone: string;
  lotEmail: string;
  zip: string;
  active: boolean;
  archived: boolean;
  lastUpdate: string;
  lanesCount: number;
  locationType: string;
  billable: boolean;
  nexResponsePriceMode?: NexResponsePriceMode;
}

export interface IBillableStatus {
  lotId: string;
  isBillable: boolean;
}

export interface ISetBulkBillableStatus {
  billableStatusList: Array<IBillableStatus>;
}

export interface GridDataResult extends DataResult {
  data: LotModel[];
  total: number;
}

export enum LocationStatusFilter {
  ALL,
  ENABLED,
  DISABLED,
  ARCHIVED,
}

export type LocationStatusFilterType = typeof LocationStatusFilter[keyof typeof LocationStatusFilter];

export const locationStatusFilterList = [
  { Name: 'Enabled', Id: LocationStatusFilter.ENABLED },
  { Name: 'Disabled', Id: LocationStatusFilter.DISABLED },
  { Name: 'Archived', Id: LocationStatusFilter.ARCHIVED },
  { Name: 'All', Id: LocationStatusFilter.ALL },
];
